import Panel from '../components/common/Panel';

export default function TermsPage() {
  return (
    <div className="page-enter min-h-screen" style={{ background: 'var(--bg-primary)' }}>
      <div className="max-w-[800px] mx-auto px-4 py-8 md:py-12">
        <h1 className="font-display text-3xl mb-2" style={{ color: 'var(--text-primary)' }}>
          Terms of Service
        </h1>
        <p className="text-sm mb-8" style={{ color: 'var(--text-muted)' }}>
          Effective Date: March 27, 2026
        </p>

        <div className="space-y-6">
          <Panel title="1. Acceptance of Terms">
            <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
              By accessing or using KOG ("the Service"), provided by Netrun Systems, a California C
              Corporation ("Company", "we", "us"), you agree to be bound by these Terms of Service.
              If you do not agree to these terms, you may not access or use the Service.
              Your continued use of the Service following any changes to these terms constitutes
              acceptance of those changes.
            </p>
          </Panel>

          <Panel title="2. Account Terms">
            <div className="text-sm leading-relaxed space-y-3" style={{ color: 'var(--text-secondary)' }}>
              <p>
                You must provide accurate and complete information when creating an account. You are
                responsible for maintaining the security of your account credentials. You must not
                share your account with any other person or entity.
              </p>
              <p>
                You are responsible for all activity that occurs under your account. You must notify
                us immediately of any unauthorized use of your account or any other breach of security.
              </p>
            </div>
          </Panel>

          <Panel title="3. Acceptable Use">
            <div className="text-sm leading-relaxed space-y-3" style={{ color: 'var(--text-secondary)' }}>
              <p>You agree not to:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>Use the Service for any illegal or unauthorized purpose</li>
                <li>Attempt to gain unauthorized access to the Service or its related systems</li>
                <li>Transmit any malicious code, viruses, or harmful data</li>
                <li>Interfere with or disrupt the integrity or performance of the Service</li>
                <li>Scrape, data mine, or use automated means to access the Service without consent</li>
                <li>Resell or redistribute the Service without written authorization</li>
              </ul>
            </div>
          </Panel>

          <Panel title="4. Intellectual Property">
            <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
              The Service and its original content, features, and functionality are and will remain
              the exclusive property of Netrun Systems. The Service is protected by copyright,
              trademark, and other laws. Our trademarks may not be used in connection with any
              product or service without the prior written consent of Netrun Systems.
              You retain all rights to the data you upload to the Service.
            </p>
          </Panel>

          <Panel title="5. Limitation of Liability">
            <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
              In no event shall Netrun Systems, its directors, employees, partners, agents,
              suppliers, or affiliates be liable for any indirect, incidental, special, consequential,
              or punitive damages, including without limitation, loss of profits, data, use, goodwill,
              or other intangible losses, resulting from your access to or use of (or inability to
              access or use) the Service. Our total liability for any claims under these terms shall
              not exceed the amount paid by you to us during the twelve months preceding the claim.
            </p>
          </Panel>

          <Panel title="6. Termination">
            <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
              We may terminate or suspend your account and access to the Service immediately, without
              prior notice or liability, for any reason, including without limitation if you breach
              these Terms. Upon termination, your right to use the Service will immediately cease.
              You may request export of your data within 30 days of termination.
            </p>
          </Panel>

          <Panel title="7. Governing Law">
            <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
              These Terms shall be governed and construed in accordance with the laws of the State
              of California, United States, without regard to its conflict of law provisions. Any
              disputes arising under these Terms shall be subject to the exclusive jurisdiction of
              the state and federal courts located in California.
            </p>
          </Panel>

          <Panel title="8. Contact">
            <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
              If you have questions about these Terms, please contact us at{' '}
              <a href="mailto:support@netrunsystems.com" style={{ color: 'var(--netrun-green)' }}>
                support@netrunsystems.com
              </a>.
            </p>
          </Panel>
        </div>

        <p className="text-xs mt-8 text-center" style={{ color: 'var(--text-muted)' }}>
          Netrun Systems &middot; California, USA
        </p>
      </div>
    </div>
  );
}
